
import { defineComponent } from "vue";
import CardGrid from "./components/CardGrid.vue";
import Menu from "./components/Menu.vue";
export default defineComponent({
    name: "App",
    components: {
        "game-menu": Menu,
        "card-grid": CardGrid
    }
});
